<div class="rt-toolbar">
  <mat-form-field class="my-form-field-color rt-filter-field" appearance="fill">
    <mat-label>Ship</mat-label>
    <mat-select [(ngModel)]="selectedShips" name="restaurantShipSelect" multiple [disabled]="availableShips.length === 1">
      @for (ship of availableShips; track ship.id_ship) {
        <mat-option [value]="ship">{{ ship.ship_name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="rt-search-btn">
    <button class="my-button confirm" mat-raised-button (click)="search()">Search</button>
  </div>

  <button class="my-button confirm rt-add-btn" mat-raised-button (click)="openCreate()">
    <mat-icon>add</mat-icon>
    <span>Add Restaurant</span>
  </button>
</div>

<div class="mat-elevation-z8 rt-table-container">
  <table mat-table [dataSource]="store.displayedItems()" [trackBy]="store.trackById">

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef class="rt-sortable-header" (click)="onSort('code')">
        Code
        <span class="rt-sort-icon">@if (sortBy === 'code') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.code }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="rt-sortable-header" (click)="onSort('name')">
        Name
        <span class="rt-sort-icon">@if (sortBy === 'name') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="shifts">
      <th mat-header-cell *matHeaderCellDef>Dinner Seating Codes</th>
      <td mat-cell *matCellDef="let row">
        <span class="rt-chips">
          @for (s of row.shifts ?? []; track s.code) {
            <span class="rt-chip">{{ s.code }} {{ s.dinner_start }}–{{ s.dinner_end }}</span>
          }
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="ship">
      <th mat-header-cell *matHeaderCellDef class="rt-sortable-header" (click)="onSort('ship')">
        Ship
        <span class="rt-sort-icon">@if (sortBy === 'ship') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.ship_id }}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef>Edit</th>
      <td mat-cell *matCellDef="let row">
        <button class="rt-icon-btn rt-edit" mat-icon-button (click)="openEdit(row)" aria-label="Edit restaurant">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef>Delete</th>
      <td mat-cell *matCellDef="let row">
        <button class="rt-icon-btn rt-delete" mat-icon-button (click)="deleteRestaurant(row)" aria-label="Delete restaurant">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">No restaurants found.</td>
    </tr>
  </table>

  <mat-paginator
    [length]="store.totalItems()"
    [pageIndex]="store.currentPage() - 1"
    [pageSize]="store.pageSize()"
    [pageSizeOptions]="[25, 50]"
    showFirstLastButtons
    (page)="onPageChange($event)">
  </mat-paginator>
</div>
